import { IonInfiniteScroll, IonInfiniteScrollContent } from "@ionic/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { incrementPage } from "../../../store/documentList";
import { selectDocuments } from "../../../store/supervisorRequiredDocuments/selectors/selectHojasDeCargo";
import { selectFindStatus } from "../../../store/supervisorRequiredDocuments/selectors/selectFindStatus";
import { DocumentSectionListLoading } from "../../DocumentList/components/DocumentSectionListLoading";
import { fetchHojasDeCargo } from "../../../store/supervisorRequiredDocuments/actions/getHojasDeCargo";
import { HojaDeCargoItem } from "./HojaDeCargoItem";
import { setViewMode } from "../../../store/supervisorRequiredDocuments";

export const HojasDeCargoList: React.FC = () => {
  const dispatch = useDispatch();

  const documents = useSelector(selectDocuments);

  const [infiniteDisabled, setInfiniteDisabled] = useState<boolean>(false);
  const findStatus = useSelector(selectFindStatus);

  useEffect(() => {
    dispatch(setViewMode("list"));
  }, [dispatch]);

  const loadData = (ev: any) => {
    setTimeout(() => {
      dispatch(incrementPage());
      dispatch(fetchHojasDeCargo());

      ev.target.complete();
      if (documents.length % 30 !== 0) {
        setInfiniteDisabled(true);
      }
    }, 500);
  };

  return (
    <section>
      {findStatus === "fulfilled" && documents.length === 0 && (
        <p className="ion-text-center" style={{ fontWeight: 300 }}>
          No se han encontrado resultados
        </p>
      )}

      <section className="ion-padding-horizontal">
        {documents?.map((document, index: number) => (
          <HojaDeCargoItem document={document} key={index} />
        ))}
      </section>

      {!documents.length && findStatus === "pending" && <DocumentSectionListLoading />}

      <IonInfiniteScroll onIonInfinite={loadData} threshold="10px" disabled={infiniteDisabled}>
        <IonInfiniteScrollContent loadingSpinner="bubbles" loadingText="Cargar más datos..." />
      </IonInfiniteScroll>
    </section>
  );
};
